/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useMemo, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateAvatarPack } from '../../../../../state/thunks/commenting';
// utils
import { url } from '../../../../../utils/urls';
// material
import { SelectableList } from '@insticator/insticator-ui'; // iui-material
import ConfigController from '../../../../../material/expandablesection/controllers/configcontroller/configcontroller'
import ExpandableSection from '../../../../../material/expandablesection/expandablesection'
import SectionDescription from '../../../../../material/expandablesection/sectiondescription/sectiondescription';
import SectionCard from '../../../../../material/expandablesection/sectioncard/sectioncard';
import SectionGroup from '../../../../../material/expandablesection/sectiongroup/sectiongroup';
import SectionGroupDescription from '../../../../../material/expandablesection/sectiongroupdescription/sectiongroupdescription'
// styles
import injectSheet from 'react-jss';
import styles from './useravatarsection_styles'
// action

const AVATOR_PACK_OPTS = [
  { value: 'DEFAULT', text: 'Default' },
  { value: 'NEWS', text: 'News' },
  { value: 'SPORTS', text: 'Sports' },
  { value: 'FINANCE', text: 'Finance' },
  { value: 'MOVIE', text: 'Movie' }
];
const renderImageNum = [
  ['1', '2', '3', '4'],
  ['5', '6', '7', '8'],
  ['9', '10', '11', '12']
];

const AvatarPreview = ({ avatarPack }) => {
  return (
    <span className={'avatarpreviewwrapper'}>
      {["1", "2", "3", "4", "5", "6"].map(i =>
        <img alt="" key={i} src={`${url.static.url}/avatars-v2/${avatarPack.toLowerCase()}-${i}.svg`} />
      )}
    </span>
  )
}
const UserAvatarSection = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const { 
    data: { 
      commentingUnitConfigurationUUID, 
      avatarPack: configAvatarPack 
    }, 
    isUpdating 
  } = useSelector(state => state.commenting.commentingConfig)
  const [avatarPack, setAvatarPack] = useState(configAvatarPack)
  const [isOpened, setIsOpened] = useState(false);


  const handleToggle = () => setIsOpened(!isOpened)

  const handleAvatarPackSave = useCallback(async () => {
    const response = await dispatch(updateAvatarPack({commentingUnitConfigurationUUID, avatarPack}))
    setIsOpened(false)
  })

  const handleCancel = () => {
    setIsOpened(false)
    setAvatarPack(configAvatarPack)
  }

  const avatorPackName = useMemo(() => {
    const selectedAvatar = AVATOR_PACK_OPTS.find(i => i.value === configAvatarPack);
    return `${selectedAvatar.text} pack`
  }, [configAvatarPack])

  const controller = (
    <ConfigController
      isOpened={isOpened}
      handleToggle={handleToggle}
      handleCancel={handleCancel}
      handleSave={handleAvatarPackSave}
      isProcessing={isUpdating.avatarPack}
      disableSave={avatarPack === configAvatarPack}
      title='User Avatars'
      description={<SectionDescription
        main={avatorPackName}
        content={
          <div className={'avatarpreview'}>
            <AvatarPreview avatarPack={configAvatarPack} />
          </div>
        }
      />}
    />
  );

  return <ExpandableSection
    className={`useravatarsection ${props.classes.useravatarsection}`}
    controller={controller}
    isOpened={isOpened}
    handleToggle={handleToggle}
    isProcessing={isUpdating.avatarPack}
    handleCancel={handleCancel}
    handleSave={handleAvatarPackSave}
    disableSave={avatarPack === configAvatarPack}
  >
    <div className={'avatarconfig'}>
      <SectionCard>
        <div className={'content'}>
          <SectionGroup>
            <SectionGroupDescription
              title='Avatar pack'
              description='Choose from different styles of user avatars. They are assigned to anonymous users and logged in users without a profile picture.'
            />
            <div className={'controls'}>
              <SelectableList type={'fancyradio'}
                items={AVATOR_PACK_OPTS}
                selected={avatarPack}
                handleChange={(value) => setAvatarPack(value)}
              />
            </div>
          </SectionGroup>
        </div>
      </SectionCard>
    </div>

    <div className={'avatarpreview'}>
      <SectionCard>
        <div className={'avatarcontainer'}>
          {!(avatarPack && Object.keys(avatarPack).length === 0 && avatarPack.constructor === Object) && avatarPack ?
            renderImageNum.map((imgNumArray, i) => {
              return <div className={'avatarset'} key={i}>
                {imgNumArray.map((imgNum, i) => {
                  return <img alt="" key={i} src={`${url.static.url}/avatars-v2/${avatarPack.toLowerCase()}-${imgNum}.svg`} />
                })}
              </div>
            }) : null}
        </div>
      </SectionCard>
    </div>
  </ExpandableSection>
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default UserAvatarSection;